<template>
  <div
    class="offcanvas offcanvas-fullscreen-sm-down offcanvas-end"
    tabindex="-1"
    id="offcanvaInfo"
    ref="offcanvaInfo"
    data-bs-backdrop="static"
  >
    <!-- data-bs-backdrop="static" -->
    <div class="bg-body-secondary border offcanvas-header py-2">
      {{ $t('Supplier Detail')  }}
      <button
        type="button"
        style="font-size: small;"
        class="btn-close shadow-none text-reset"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      />
    </div>

    <div
      class="offcanvas-body"
      v-if="loading"
    >
      <placeholder-content :is-load="true" />
    </div>
    <div
      class="offcanvas-body p-0"
      v-else
    >
      <div class="border-bottom py-2 px-3">
        <div class="row g-3 py-2">
          <b style="font-size: 18px;">
            {{ data.fullname }}
          </b>
          <div
            class="d-flex mt-0 "
            style="font-size: 13px;"
          >
            <label
              class="pe-2"
            >
              {{ $t('Last Update') + ': ' + formatDateTime(data.updated_at) }}
            </label>
          </div>
        </div>
      </div>
      <div class="card m-3 mb-0">
        <div class="card-header">
          <i class="fa-solid fa-circle-info me-2" />
          {{ $t('Supplier Information') }}
        </div>
        <div class="card-body pb-0">
          <div class="row" style="font-size: 13px;">
            <div class="col-6 col-md-2 mb-3">
              <b>
                <i class="fa-solid fa-code-branch me-1" />
                {{ $t('Branch') + ':' }}
              </b>
            </div>
            <div class="col-6 col-md-4 mb-3">
              {{ data.branch || '-' }}
            </div>
            <div class="col-6 col-md-2 mb-3">
              <b>
                <i class="fa-solid fa-id-card me-1" />
                {{ $t('Tax ID') + ':' }}
              </b>
            </div>
            <div class="col-6 col-md-4 mb-3">
              {{ data.tax_id || '-' }}
            </div>
            <div class="col-6 col-md-2 mb-3">
              <b>
                <i class="fa-solid fa-envelope me-1" />
                {{ $t('Email') + ':' }}
              </b>
            </div>
            <div class="col-6 col-md-4 mb-3">
              <a v-if="data.email"
                :href="'mailto:' + data.email">{{
                  data.email
                }}
              </a>
              <template v-else>
                -
              </template>
            </div>
            <div class="col-6 col-md-2 mb-3">
              <b>
                <i class="fa-solid fa-phone me-1" />
                {{ $t('Telephone') + ':' }}
              </b>
            </div>
            <div class="col-6 col-md-4 mb-3">
              <a v-if="data.telephone1"
                :href="'tel:' + data.telephone1">{{
                  data.telephone1
                }}
              </a>
              <template v-else>
                -
              </template>
              <template v-if="data.telephone2">
                ,
                <a
                  :href="'tel:' + data.telephone2">{{
                    data.telephone1
                  }}
                </a>
              </template>
            </div>
            <div class="col-6 col-md-2 mb-3">
              <b>
                <i class="fa-solid fa-user-pen me-1" />
                {{ $t('Create By') + ':' }}
              </b>
            </div>
            <div class="col-6 col-md-4 mb-3">
              {{ data.created_by }}
            </div>
            <div class="col-6 col-md-2 mb-3">
              <b>
                <i class="fa-solid fa-map-location-dot me-1" />
                {{ $t('Address') + ':' }}
              </b>
            </div>
            <div
              v-if="
                (data.address || false) &&
                (data.sub_district || false) &&
                (data.district || false) &&
                (data.province || false) &&
                (data.postal_code || false)
              "
              class="col-6 col-md-4 mb-3">
              {{
                data.address + ' ' +
                data.sub_district + ' ' +
                data.district + ' ' +
                data.province + ' ' +
                data.postal_code
              }}
            </div>
            <div v-else class="col-6 col-md-4 mb-3">
              -
            </div>
          </div>
        </div>
      </div>
      <div class="card m-3">
        <div class="card-header">
          <i class="fa-solid fa-clipboard me-2" />
          {{ $t('Activity Logs') }}
        </div>
        <div class="card-body p-0">
          <div
            v-if="data.logs.length == 0"
            class="text-center m-3"
          >
            {{ $t('No Data Available') }}
          </div>
          <table
            v-else
            class="m-1"
            width="100%"
          >
            <tbody
              class="text-muted"
              style="font-size: 14px;"
            >
              <tr
                v-for="log of data.logs"
              >
                <td class="text-start align-top ms-1" width="50%">
                  - {{ $t(log.message) + ' ' + $t(log.value) }}
                </td>
                <td class="text-start align-top">
                  <i class="fa-regular fa-calendar-days me-1" />
                  {{ dateDistance(log.updated_at) }}
                </td>
                <td class="text-start align-top">
                  <i class="fa-solid fa-user-pen me-1" />
                  {{ $t(log.created_by) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div
      class="bg-light border-top justify-content-center modal-footer py-2"
      v-if="!loading"
    >
      <div class="btn-group dropdown">
        <button type="button" class="btn btn-sm btn-primary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
          <i class="fa-solid fa-ellipsis me-1" />
          {{ $t('More Action') }}
        </button>
        <ul class="dropdown-menu">
          <li>
            <a
              class="dropdown-item"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
              @click="() => {
                $parent.form.open = true;
                $parent.form.viewOnly = false;
                $parent.form.supplierId = supplierId;
                $parent.form.type = 'EDIT';
              }"
            >
              <i class="fa-solid fa-square-pen" />
              {{ $t('Edit') }}
            </a>
          </li>
          <li>
            <a
              class="dropdown-item"
              @click="handleDelete()"
            >
              <i class="fa-solid fa-trash-can" />
              {{ $t('Delete') }}
            </a>
          </li>
        </ul>
      </div>
      <button
        type="button"
        data-bs-dismiss="offcanvas"
        class="border-dark-subtle btn-sm btn btn-light me-2 ms-2"
      >
        {{ $t('Cancel') }}
      </button>
    </div>
  </div>
</template>

<script lang="js">
import Select2 from 'vue3-select2-component';
import { Suppliers } from '@/services/endpoint/suppliers.service';
import PlaceholderContent from '@/plugins/PlaceholderContent.vue';
import Ladda from '@/plugins/Ladda.vue';
import moment from "moment";
import { distance } from '@/store/date-fns'

export default {
  props: {
    supplierId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loadingCard: true,
      loading: true,
      showLogs: true,
      data: {
        name: '',
        total_net_quantity: 0,
        net_quantity_cost: 0,
        unit_id: '1',
      },
      tabCards: [
        {
          id: 1,
          name: 'Activity Logs',
          disabled: false
        },
        {
          id: 2,
          name: 'Unusable',
          disabled: false
        }
      ],
      selectTabCard: 1
    }
  },
  components: {
    Select2,
    PlaceholderContent,
    Ladda
  },
  methods: {
    async getInfoData() {
      await Suppliers.getInfo(this.supplierId).then(res => {
        this.data = res.data.data;
        this.showLogs = true;
        this.loadingCard = false;
      }).catch(err => {
			  throw err;
      });
    },
    formatDateTime(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss');
    },
    dateDistance(value) {
      return distance(value);
    },
    async handleDelete() {
      try {
        let self = this;
        let title = this.$t("Delete Supplier") + '?';
        let html = this.$t("You will not be able to undo this action.");
        let confirmButtonText =
          '<i class="fas fa-check-circle me-1"></i>' + this.$t("Confirm");
        this.$swal({
          icon: "warning",
          iconColor: "#FF7043",
          title: title,
          // text: "You will not be able to undo this action.",
          html: html,
          showCancelButton: true,
          cancelButtonText: this.$t("Cancel"),
          confirmButtonText: confirmButtonText,
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-primary me-2",
            cancelButton: "btn btn-danger",
          },
          focusConfirm: false,
          showLoaderOnConfirm: true,
          preConfirm: async function () {
            return Suppliers.delete(self.supplierId)
              .then((response) => {
                self.$parent.fetchData();
                self.$toast.success("<B>" + self.$t('Success') + "</B>\n" + self.$t('Delete Product Success!'));
                $(self.$refs.offcanvaInfo).offcanvas('hide');
              })
              .catch((error) => {
                if (error?.response?.status === 403) {
                  self.$swal.update({
                    title: self.$t('Access Denied'),
                    confirmButtonText: '<i class="fas fa-redo me-1"></i>' + self.$t("Try again"),
                    text: self.$t('You do not have permission to access this page.')
                  });
                  self.$swal.showValidationMessage(
                    self.$t(error?.response?.data?.message)
                  )
                } else {
                  self.$toast.warn(error?.response?.data?.message);
                }
              })
          },
        });
      } catch (error) {
      }
    },
  },
  async mounted() {
    $(this.$refs.offcanvaInfo).offcanvas('show');

    $(this.$refs.offcanvaInfo).on('shown.bs.offcanvas',async () => {
      this.loading = true;
      try {
        await this.getInfoData();
        this.loading = false;
      } catch (err) {
      }
    });

    $(this.$refs.offcanvaInfo).on('hidden.bs.offcanvas', () => {
      this.$parent.formInfo.open = false;
    });
  },
  computed: {

  }
}
</script>
